import { render, staticRenderFns } from "./CamDetail.vue?vue&type=template&id=15c578a2&scoped=true"
import script from "./CamDetail.vue?vue&type=script&lang=js"
export * from "./CamDetail.vue?vue&type=script&lang=js"
import style0 from "./CamDetail.vue?vue&type=style&index=0&id=15c578a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c578a2",
  null
  
)

export default component.exports